// components/CronJobLogsViewer.js
import React, { useEffect, useState } from "react";
import axios from "../utils/axios"; // ✅ Make sure baseURL is set to http://localhost:5000 or use full URL
import './styles/CronStatusViewer.css';
export default function CronStatus  () {
  const [logs, setLogs] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const res = await axios.get("/cronlogs"); // or "/api/cronlogs" depending on backend routing
      setLogs(res.data);
    } catch (err) {
      console.error("Error fetching cron logs:", err);
      setError("Failed to load cron logs.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 bg-white rounded shadow max-w-4xl mx-auto mt-10">
      <h2 className="text-xl font-semibold mb-4">🧾 Cron Job Logs</h2>

      {loading && <p>Loading...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {logs.length > 0 ? (
        <table className="min-w-full table-auto border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 border">Type</th>
              <th className="px-4 py-2 border">Date</th>
              <th className="px-4 py-2 border">Time</th>
              <th className="px-4 py-2 border">Result</th>
              <th className="px-4 py-2 border">Message</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log, index) => (
              <tr key={index} className="text-center">
                <td className="border px-4 py-2">{log.type}</td>
                <td className="border px-4 py-2">{log.date}</td>
                <td className="border px-4 py-2">{log.time}</td>
                <td
                  className={`border px-4 py-2 font-semibold ${
                    log.result === "Success" ? "text-green-600" : "text-red-600"
                  }`}
                >
                  {log.result}
                </td>
                <td className="border px-4 py-2 text-left">{log.message || "-"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p className="text-gray-600">No logs found.</p>
      )}
    </div>
  );
}
